import { InternalLinkContextProvider, InternalLinkProps, InternalLinkReplacements } from '@boxcryptor-web/ui';
import { Link } from 'gatsby';
import React from 'react';
import { getReplacedInternalLink, shouldRenderAsInternalLink } from './link';
import { useLinkIdContext } from './LinkIdContext';

const InternalLinkComponent: React.FC<InternalLinkProps> = (props) => {
  const { idPrefix } = useLinkIdContext();
  const id = idPrefix && props.trackingId ? `${idPrefix}:${props.trackingId}` : undefined;
  const linkProps = { ...props, trackingId: undefined };
  return <Link {...linkProps} id={id} />;
};
export const GatsbyLinkContextProvider: React.FC<{
  internalLinkReplacements: InternalLinkReplacements;
  allInternalLinks: string[];
  baseUrl: string;
  children?: React.ReactNode;
}> = ({ internalLinkReplacements, allInternalLinks, baseUrl, children }) => {
  return (
    <InternalLinkContextProvider
      value={{
        internalLinkComponent: (props) => <InternalLinkComponent {...props} />,
        shouldRenderAsInternalLink: (to: string) => shouldRenderAsInternalLink({ to, allInternalLinks, baseUrl }),
        getReplacedInternalLink: (to: string) => getReplacedInternalLink({ to, replacements: internalLinkReplacements, baseUrl }),
        baseUrl,
      }}
    >
      {children}
    </InternalLinkContextProvider>
  );
};
